import { useStore } from 'vuex';
import { useKillswitches, useProductFlags } from '@modules/featureControl';
import { useModal } from '@composables/utils/useModal';
import { usePageData } from '@composables/usePageData';
import { useBrand } from '@composables/useBrand';
import { useProductImagesCtaActions } from './useProductImagesCtaActions';

export const useVtoCta = () => {
  const { isMasterProductFlag, isModifaceEnabledFlag } = useProductFlags();
  const { killswitches } = useKillswitches();
  const { addCtaItem } = useProductImagesCtaActions();
  const { open } = useModal();
  const { isMcom } = useBrand();
  const store = useStore();
  const { productId } = usePageData();
  const vtoEligible = killswitches?.isModifaceEnabled && isModifaceEnabledFlag && !isMasterProductFlag && isMcom;

  // TODO: investigate !isMemberOfMaster

  const init = () => {
    if (vtoEligible) {
      addCtaItem({
        customCssClass: 'font-small',
        id: 'vto',
        label: 'TRY IT<br>ON NOW',
        onClickHandler: () => {
          open('VTO');
          store.commit('VTO/setProductId', productId);
        },
      });
    }
  };

  return {
    init,
  };
};

export default useVtoCta;
